import { render, staticRenderFns } from "./orderServicerReturnVisit.vue?vue&type=template&id=2ec0df40&"
import script from "./orderServicerReturnVisit.vue?vue&type=script&lang=ts&"
export * from "./orderServicerReturnVisit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports